export default {
  init() {
    window.OneSignal = window.OneSignal || [];
    /* Why use .push? See: http://stackoverflow.com/a/38466780/555547 */
    window.OneSignal.push(function() {
      /* Never call init() more than once. An error will occur. */
      window.OneSignal.init(window._oneSignalInitOptions);
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js